// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@awc/App/Widgets/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@awc/App/Widgets/GoogleAnalyticsConnector/Utilities/DataLayer";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteLoadSession } from "@insite/client-framework/Store/Context/Handlers/SetDashboardIsHomepage";

export const _GaSendTracking: typeof DispatchCompleteLoadSession = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    if (state.xGoogleAnalytics.setDasboardAsHomepageEvent && props.parameter.dashboardIsHomepage) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.setDasboardAsHomepageEventName,
            affiliation: state.xGoogleAnalytics.affiliation,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToEndOfChain(chain, _GaSendTracking);